import React, { useState, useEffect } from 'react'
import {Row, Col, Form, Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'


export default function RegexpSeoHelper({ disabled }) {
  const [combinazioni, setCombinazioni] = useState({
    first: '',
    second: '',
  })

  const [regex, setRegex] = useState('')
  const [show, setShow] = useState(false);

  const toggle = () => setShow(!show);

  const wordPlaceholder = 'inserisci una parola'

  /**
   * Builds a regex based on the words given
   */
  const buildRegex = (words) => {
    let regex = ''

    if (combinazioni['first'] !== '' && combinazioni['second'] !== '')
      regex =
        '(?:\\b(' +
        combinazioni['first'] +
        ')\\b.*\\b(' +
        combinazioni['second'] +
        ')\\b|\\b(' +
        combinazioni['second'] +
        ')\\b.*\\b(' +
        combinazioni['first'] +
        ')\\b|\\b(' +
        combinazioni['first'] + combinazioni['second'] +
        ')\\b)'

    setRegex(regex)
  }

  useEffect(() => buildRegex(combinazioni), [combinazioni])

  return (
    <>
      <Modal
        isOpen={show}
        toggle={toggle}
        backdrop={true}
        size="lg"
        centered
      >
        <ModalHeader toggle={toggle}>
            <h4>Regex helper</h4>
        </ModalHeader>

        <ModalBody>
          <Form onSubmit={''}>
            <Row>
              <Col xs={4} className={'pb-3'}>
                <label>Combinazione 1</label>
                <input
                  type="text"
                  className="form-control"
                  required
                  placeholder={wordPlaceholder}
                  value={combinazioni['first']}
                  onChange={(e) =>
                    setCombinazioni({ ...combinazioni, first: e.target.value })
                  }
                />
              </Col>
              <Col xs={4} className={'pb-3'}>
                <label>Combinazione 2</label>
                <input
                  type="text"
                  className="form-control"
                  required
                  placeholder={wordPlaceholder}
                  value={combinazioni['second']}
                  onChange={(e) =>
                    setCombinazioni({ ...combinazioni, second: e.target.value })
                  }
                />
              </Col>
              <Col xs={4} className={'pb-3'}>
                <label>Regex</label>
                <input
                  type="text"
                  className="form-control"
                  required
                  value={regex}
                />
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={() =>
              regex !== '' ? navigator.clipboard.writeText(regex) : ''
            }
          >
            Copia Regex
          </Button>
          <Button
            color="danger"
            onClick={() => setCombinazioni({ first: '', second: '' })}
          >
            Reset
          </Button>
          <Button variant="secondary" onClick={toggle}>
            Chiudi
          </Button>
        </ModalFooter>
      </Modal>
      <Button
        color="info"
        onClick={(e) => setShow(!show)}
        disabled={disabled}
      >
        <i class="fas fa-hammer"></i> Costruisci regex
      </Button>
    </>
  )
}
